import { render, staticRenderFns } from "./NewPostMenu.vue?vue&type=template&id=08eee9b4&scoped=true&"
import script from "./NewPostMenu.vue?vue&type=script&lang=js&"
export * from "./NewPostMenu.vue?vue&type=script&lang=js&"
import style0 from "./NewPostMenu.vue?vue&type=style&index=0&id=08eee9b4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eee9b4",
  null
  
)

export default component.exports